import React from 'react';

import UpgradeWrapper from 'features/permissions/UpgradeWrapper';

import Box from 'components/Box';
import Text from 'components/Text';
import TooltipIcon from 'components/TooltipIcon';

import { toI18n } from 'util/i18n';

import LevelItem from './LevelItem';
const I18N_ACCESS_LEVELS_PATH = 'team.access_levels';
const AccessLevel = ({ handleChange, cxEl, level, accessLevelOptions }) => {
  const levelOptions = accessLevelOptions.map(lo => lo.label);
  return (
    <Box>
      <Box mb={8} row>
        <Box vbottom>
          <Text fs14 fw600 i18n="add_team.individual_drawer.access_level" />
        </Box>
        <Box vbottom>
          <TooltipIcon
            color="grayDark"
            size={10}
            content={toI18n('add_team.individual_drawer.tooltip')}
          />
        </Box>
      </Box>

      <Box row>
        {levelOptions.includes(
          toI18n(`${I18N_ACCESS_LEVELS_PATH}.employee`)
        ) && (
          <LevelItem
            value={toI18n(`${I18N_ACCESS_LEVELS_PATH}.employee`)}
            label="employee"
            level={level}
            handleChange={handleChange}
            className={cxEl('level')}
          />
        )}

        {levelOptions.includes(
          toI18n(`${I18N_ACCESS_LEVELS_PATH}.manager`)
        ) && (
          <UpgradeWrapper
            feature="managers"
            focusedFeature="permissionAndDepartments"
          >
            <LevelItem
              value={toI18n(`${I18N_ACCESS_LEVELS_PATH}.manager`)}
              label="manager"
              level={level}
              handleChange={handleChange}
              className={cxEl('level')}
            />
          </UpgradeWrapper>
        )}

        {levelOptions.includes(
          toI18n(`${I18N_ACCESS_LEVELS_PATH}.general_manager`)
        ) && (
          <UpgradeWrapper
            feature="gm"
            focusedFeature="permissionAndDepartments"
          >
            <LevelItem
              value={toI18n(`${I18N_ACCESS_LEVELS_PATH}.general_manager`)}
              label="gm"
              level={level}
              handleChange={handleChange}
              className={cxEl('level')}
            />
          </UpgradeWrapper>
        )}
      </Box>
    </Box>
  );
};

export default AccessLevel;
